export const searchCategories = [
  ["all", "All"],
  ["artist", "Artists"],
  ["event", "Events"],
  ["track", "Tracks"],
  ["release", "Releases"],
  ["post", "Articles"],
  ["news", "News"],
  ["venue", "Venues"],
  ["glossary", "Glossary"],
  ["interview", "Interviews"],
  ["playlist", "Playlists"],
  ["tag", "Topics"],
] as const;
export type SearchType = (typeof searchCategories)[number][0];
export interface SearchResult {
  id: string | number;
  title: string;
  description: string | null;
  image_url: string | null;
  image_data?: any;
  type: Exclude<SearchType, "all">;
  created_at: string;
  start_date?: string;
  end_date?: string;
  event_timezone?: string;
  additional_info?: {
    cityName?: string;
    countryName?: string;
    hasExactTimes?: boolean;
  };
  url: string;
}
export interface SearchResponse {
  results: SearchResult[];
  total: number;
  counts?: Partial<Record<SearchType, number>>;
  hasMore?: boolean;
  query?: string;
  limit?: number;
  offset?: number;
}
